import { mergeToken } from 'antd/es/theme/internal';
import { initInputToken, genStatusStyle } from '../../input/style/styleConfig.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var antPrefixCls = '.ant-input-number';
var genInputNumberStyles = function genInputNumberStyles(token) {
  var _extends2, _antInputNumberA, _ref;
  return [(_ref = {}, _ref[antPrefixCls] = _extends({}, genStatusStyle(token, antPrefixCls), (_extends2 = {}, _extends2["&" + antPrefixCls + "-sm"] = {
    // pebble 新增 token
    fontSize: token.fontSizeSM
  }, _extends2)), _ref['.ant-input-number .ant-input-number-handler:active'] = (_antInputNumberA = {}, _antInputNumberA['.anticon'] = {
    color: token.colorText
  }, _antInputNumberA), _ref['.ant-input-number-outlined.ant-input-number-disabled,.ant-input-number-outlined[disabled]'] = {
    borderColor: token.disabledBorderColor + "!important"
  }, _ref['.ant-input-number-group-wrapper-outlined.ant-input-number-group-wrapper-disabled .ant-input-number-group-addon'] = {
    borderColor: token.disabledBorderColor + " !important"
  }, _ref)];
};
var inputNumberStyleFn = function inputNumberStyleFn(token) {
  var InputNumberToken = initInputToken(mergeToken(token));
  return [genInputNumberStyles(InputNumberToken)];
};

export { inputNumberStyleFn };
